import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { NavigationEnd, Params, Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class NavigationService {
    private history: string[] = [];

    constructor(private router: Router, private location: Location) {
        this.router.events.subscribe({
            next: (event: any) => {
                if (event instanceof NavigationEnd) {
                    this.history.push(event.urlAfterRedirects);
                }
            }
        });
    }

    /**
     * Goes to the local URL. Such as "/magic".
     * @param local
     */
    public goto(local: string, params: Params | undefined | null = null) {
        if (!params) {
            this.router.navigate([local], {
                replaceUrl: false
            });
        } else {
            this.router.navigate([local], {
                queryParams: params,
                onSameUrlNavigation: 'reload'
            });
        }
    }

    public gotoLogin() {
        this.goto("/login");
    }

    /**
     * Navigates to the previous page.
     * If there was no previous page then navigate to either the front page or user profile.
     * @param username
     */
    public back(username?: string): void {
        this.history.pop(); // this page
        var prevPage = this.history.pop();

        if (prevPage) {
            //this.location.back();
            this.router.navigateByUrl(prevPage);
        } else {
            if (username) {
                this.router.navigateByUrl(`/user/${username}`);
            } else {
                this.router.navigateByUrl("/");
            }
        }
    }

    /**
     * Reloads the page.
     */
    public reload(): void {
        location.reload();
    }
}